export class EstadoAccion {
  ID: number;
  NOMBRE: string;
}
